import React, { memo } from "react";
import { Modal } from "react-bootstrap";
import InputText from "../../common/Input/InputText";
import InputOnlyNumber from "../../common/Input/InputOnlyNumber";

const AddUpdatePhysiotherapy = ({
  showModal,
  setModalVisible,
  modalAction,
  handleChange,
  formData,
  handleCreatePhysiotherapyService,
  setInputError,
  inputError,
  initialState,
  setFormData,
  submitLoading,
}) => {
  return (
    <>
      <Modal
        centered
        show={showModal}
        onHide={() => {
          setModalVisible(false);
          setInputError({
            serviceDetailName: "",
          });
          setFormData(initialState);
        }}
        size="md"
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {modalAction === "create"
              ? "Add Physiotherapy Service"
              : "Update Physiotherapy Service"}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setModalVisible(false);
              setInputError({
                serviceDetailName: "",
              });
              setFormData(initialState);
            }}
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleCreatePhysiotherapyService}>
            <div className="row">
              <div className="col-xl-12">
                <InputText
                  name="serviceDetailName"
                  value={formData?.serviceDetailName}
                  onChange={handleChange}
                  label="Service Detail Name"
                  setInputTextError={setInputError}
                />
                {inputError?.serviceDetailName && (
                  <p className="text-danger mb-0">
                    {inputError.serviceDetailName}
                  </p>
                )}
              </div>
              <div className="col-xl-12">
                <InputOnlyNumber
                  value={formData?.pt_price}
                  onChange={handleChange}
                  name="pt_price"
                  label="Pateint Price"
                  setInputTextError={setInputError}
                />
              </div>
              <div className="col-xl-12">
                <InputOnlyNumber
                  value={formData?.client_price}
                  onChange={handleChange}
                  name="client_price"
                  label="Client Price"
                  setInputTextError={setInputError}
                />
              </div>
              <div className="col-xl-12">
                <InputOnlyNumber
                  value={formData?.tax}
                  onChange={handleChange}
                  name="tax"
                  label="Tax"
                  setInputTextError={setInputError}
                />
              </div>
              <div className="col-xl-12">
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="status" className="col-form-label me-3">
                    Status:
                  </label>
                  {["Active", "Inactive", "Deleted"].map((status) => (
                    <div className="form-check me-3" key={status}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="status"
                        id={status.toLowerCase()}
                        value={status}
                        checked={formData?.status === status}
                        onChange={handleChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={status.toLowerCase()}
                      >
                        {status}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                disabled={submitLoading}
              >
                {submitLoading ? (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                ) : null}
                {submitLoading
                  ? "Please wait..."
                  : formData?.id || formData?.userId
                    ? "Update"
                    : "Add"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default memo(AddUpdatePhysiotherapy);
